import React, { Fragment } from 'react';
import { TableCell, TableRow, SvgIcon, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import { DeleteIcon } from 'Icons';
import { getRowValue } from './cellRenderer';
import staticText from 'static/text_display.json';
import { formatMessage } from 'utils/methods/helpers';

const Row = props => {
  const {
    row: { rawData, rowData },
    setValue,
    value: evidenceValues,
    classes,
    t,
    handleDelete,
    disabled,
  } = props;

  return (
    <TableRow>
      {Object.entries(rowData).map(([key, value]) => {
        return (
          <Fragment key={key}>
            <TableCell
              // style={{ textAlign: '-webkit-center' }} //When we align using textAlign property,
              //align centers the text, -webkit-center will center the text and the image.
              // classes={{ root: classes.rootCell }}
              key={key}
            >
              {getRowValue({
                data: value,
                setValue,
                evidenceValues,
                rawData,
                rowData,
                disabled,
                t,
              })}
            </TableCell>
          </Fragment>
        );
      })}

      <TableCell>
        {!disabled && (
          <IconButton
            color="secondary"
            component="div"
            onClick={() => handleDelete(rawData)}
            title={t(
              formatMessage({
                message: staticText.general.delete_value,
              }),
            )}
          >
            <SvgIcon className={classes.mySvgStyle}>
              <DeleteIcon />
            </SvgIcon>
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
};

Row.propTypes = {
  row: PropTypes.object,
  collapisble: PropTypes.bool,
  onDelete: PropTypes.func,
  setValue: PropTypes.func,
  onEdit: PropTypes.func,
  t: PropTypes.func,
  handleDelete: PropTypes.func,
  allowEditRow: PropTypes.bool,
  allowDeleteRow: PropTypes.bool,
  subTable: PropTypes.object,
  value: PropTypes.array,
  classes: PropTypes.string,
  showMediaInPortal: PropTypes.bool,
  disabled: PropTypes.bool,
  displayImageInPortal: PropTypes.func,
};

export default Row;
